export default function Footer() {
    return (
        <footer className="border-t border-slate-200 bg-white py-4 text-center text-sm text-slate-500">
            Make Merry LLC
        </footer>
    )
}
